<template>
    <intelligence-shell
        :title="title"
        :subtitle="subtitle"
        :specialityOptions="specialityOptions"
        :stateOptions="stateOptions"
        :insurancePlanOptions="insurancePlanOptions"
        @filters-change="onFiltersChange"
    >
        <router-view :filters="filters"></router-view>
    </intelligence-shell>
</template>

<script>
    import { mapGetters } from 'vuex'
    import IntelligenceShell from 'components/page-elements/intelligence/IntelligenceShell'
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import StatesAPI from 'api/StatesAPI'

    const PAGE_KEYS = {
        'intelligence.overview': 'overview',
        'intelligence.constraints': 'constraints',
        'intelligence.delivery': 'delivery',
        'intelligence.supply-demand': 'supply_demand',
        'intelligence.entitlement': 'entitlement',
        'intelligence.patient-friction': 'patient_friction',
        'intelligence.provider-performance': 'provider_performance',
        'intelligence.provider-competition': 'provider_competition',
    }

    export default {
        components: {
            IntelligenceShell,
        },

        data() {
            return {
                filters: null,
                specialityOptions: [],
                stateOptions: [],
            }
        },

        computed: {
            ...mapGetters('auth', {
                storedInsurancePlans: 'getInsurancePlans',
            }),

            insurancePlanOptions() {
                return this.storedInsurancePlans || []
            },

            pageKey() {
                return PAGE_KEYS[this.$route.name] || 'overview'
            },

            title() {
                return this.$t(`pages.intelligence.${this.pageKey}.title`)
            },

            subtitle() {
                return this.$t(`pages.intelligence.${this.pageKey}.subtitle`)
            },
        },

        methods: {
            onFiltersChange(filters) {
                this.filters = filters
            },

            loadFilterOptions() {
                return Promise.all([SpecialitiesAPI.getList(), StatesAPI.getList()]).then(([specialities, states]) => {
                    this.specialityOptions = specialities || []
                    this.stateOptions = states || []
                })
            },
        },

        created() {
            this.loadFilterOptions()
        },
    }
</script>
